import { render, staticRenderFns } from "./AuthMethod.vue?vue&type=template&id=7867c732&"
import script from "./AuthMethod.vue?vue&type=script&lang=ts&"
export * from "./AuthMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports